"use client"

import { useRouter, useSearchParams } from "next/navigation"
import { FormEvent, useState, useEffect } from "react"

export default function SearchBar() {
  const router = useRouter()
  const searchParams = useSearchParams()
  const [searchTerm, setSearchTerm] = useState("")

  useEffect(() => {
    const q = searchParams.get("q")
    setSearchTerm(q || "")
  }, [searchParams])

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (!searchTerm.trim()) {
      return
    }

    const params = new URLSearchParams()
    params.set("q", searchTerm.trim())
    router.push(`/store?${params.toString()}`)
  }

  const handleClear = () => {
    setSearchTerm("")
    router.push("/store")
  }

  return (
    <form onSubmit={handleSubmit} className="flex-1 max-w-3xl w-full">
      <div className="flex items-stretch bg-white rounded-md overflow-hidden shadow-sm">
        <input
          type="text"
          placeholder="Search products..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="flex-1 px-4 py-2 text-base text-gray-900 outline-none"
        />
        {searchTerm && (
          <button
            type="button"
            onClick={handleClear}
            className="px-3 hover:bg-gray-100 transition-colors flex items-center"
            aria-label="Clear search"
          >
            <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
        <button
          type="submit"
          className="bg-slate-500 hover:bg-slate-600 px-4 transition-colors flex items-center"
          aria-label="Search"
        >
          <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </button>
      </div>
    </form>
  )
}
